import { render, staticRenderFns } from "./EmergencyHistoryTable.vue?vue&type=template&id=4c401b08&scoped=true"
import script from "./EmergencyHistoryTable.vue?vue&type=script&lang=js"
export * from "./EmergencyHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./EmergencyHistoryTable.vue?vue&type=style&index=0&id=4c401b08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c401b08",
  null
  
)

export default component.exports